<template>
  <div>
    <!-- Information banner about the search -->
    <v-alert
      color="info"
      border="left"
      colored-border
      icon="mdi-information"
      class="mb-4"
    >
      <strong>Search:</strong> Search by any single field (e.g., Hygienist ID,
      Email, First Name, or Last Name). Email search matches the user's account
      email exactly.
    </v-alert>

    <v-form ref="form" v-model="valid" lazy-validation>
      <div>
        <v-row class="ml-4">
          <span class="name_span">Hygienist/Assistant:</span>
          <v-col sm="2"
            ><v-text-field
              outlined
              v-model="hygienist.firstName"
              placeholder="First Name"
              @input="$refs.form.resetValidation()"
              dense
            ></v-text-field
          ></v-col>
          <v-col sm="2"
            ><v-text-field
              outlined
              v-model="hygienist.lastName"
              @input="$refs.form.resetValidation()"
              placeholder="Last Name"
              hint="Not required"
              dense
            ></v-text-field
          ></v-col>
          <v-col sm="2"
            ><v-text-field
              outlined
              v-model="hygienist.id"
              @input="$refs.form.resetValidation()"
              placeholder="Hygienist id"
              :rules="[v => typeof v == 'number']"
              hint="Not required"
              dense
            ></v-text-field
          ></v-col>
          <v-col sm="2"
            ><v-text-field
              outlined
              v-model="hygienist.email"
              @input="$refs.form.resetValidation()"
              placeholder="Hygienist Email"
              hint="Not required"
              dense
            ></v-text-field
          ></v-col>
        </v-row>
      </div>
      <div>
        <v-row class="ml-4">
          <span class="name_span">Location: </span>
          <v-col sm="2"
            ><v-text-field
              outlined
              v-model="location.name"
              @input="$refs.form.resetValidation()"
              placeholder="Location Name"
              dense
            ></v-text-field
          ></v-col>
          <v-col sm="2"
            ><v-text-field
              outlined
              v-model="location.address"
              @input="$refs.form.resetValidation()"
              placeholder="Adrress"
              dense
            ></v-text-field
          ></v-col>
          <v-col sm="2"
            ><v-text-field
              outlined
              v-model="location.id"
              @input="$refs.form.resetValidation()"
              placeholder="Location id"
              :rules="[v => typeof v == 'number']"
              hint="Not required"
              dense
            ></v-text-field
          ></v-col>
          <v-col sm="2"
            ><v-text-field
              outlined
              v-model="location.email"
              @input="$refs.form.resetValidation()"
              placeholder="Location email"
              hint="Not required"
              dense
            ></v-text-field
          ></v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-col sm="2">
          Job ID:
          <v-text-field
            solo
            v-model="jobId"
            @input="$refs.form.resetValidation()"
            placeholder="Job id"
            :rules="[v => typeof v == 'number']"
            hint="Not required"
            dense
          ></v-text-field>
        </v-col>
      </div>
      <v-btn color="primary" class="mr-4" @click="searchData()">
        Search
        <v-icon>find_in_page</v-icon>
      </v-btn>

      <v-btn @click="clear" small text> Clear </v-btn>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

export default {
  name: "getLocationHygienist",
  data: () => ({
    valid: true,
    jobId: null,
    hygienist: {
      firstName: "",
      lastName: "",
      email: "",
      id: null
    },
    location: {
      name: "",
      address: "",
      email: "",
      id: null
    }
  }),
  created() {
    if (this.$route.query.jobId) {
      this.jobId = this.$route.query.jobId;
      this.searchData();
    }
    if (this.$route.query.hygienistId) {
      this.hygienist.id = this.$route.query.hygienistId;
      this.searchData();
    }
  },
  methods: {
    ...mapActions(["getDataForDispute"]),
    ...mapMutations(["modifyMultiple"]),
    clear: function() {
      this.hygienist = {
        firstName: "",
        lastName: "",
        email: "",
        id: null
      };
      this.location = {
        name: "",
        address: "",
        email: "",
        id: null
      };
      this.jobId = null;
    },
    searchData: async function() {
      this.$emit("loading");
      try {
        // Build search payload for the backend dispute search endpoint
        // This endpoint properly joins with User table to search by email
        const searchPayload = {
          hygienist: {
            id: this.hygienist.id ? Number(this.hygienist.id) : null,
            firstName: this.hygienist.firstName || "",
            lastName: this.hygienist.lastName || "",
            email: this.hygienist.email || ""
          },
          location: {
            id: this.location.id ? Number(this.location.id) : null,
            name: this.location.name || "",
            address: this.location.address || "",
            email: this.location.email || ""
          },
          jobId: this.jobId ? Number(this.jobId) : null
        };

        console.log("🔍 Search payload:", searchPayload);

        const data = await this.getDataForDispute(searchPayload);

        if (
          data &&
          ((data.hygienists && data.hygienists.length > 0) ||
            (data.locations && data.locations.length > 0))
        ) {
          this.$emit("next");
          this.clear();
        } else {
          // No results found
          this.modifyMultiple([
            {
              property: "ErrorDialogShow",
              value: true
            },
            {
              property: "ServerError",
              value:
                "No results found matching your search criteria. Please try different search terms."
            }
          ]);
          this.$emit("error");
          this.clear();
        }
      } catch (err) {
        this.$emit("error");
        this.clear();
        this.modifyMultiple([
          {
            property: "ErrorDialogShow",
            value: true
          },
          {
            property: "ServerError",
            value: err.message || "Search failed. Please try again."
          }
        ]);
      }
    }
  }
};
</script>

<style scoped>
.name_span {
  line-height: 4em;
  min-width: 165px;
}
.full_cols {
  min-height: max-content;
}
</style>
